import React from 'react';
import { CreateTicketSC } from './CreateTicket.style';
import CreateTicketStep1 from './create-ticket-step-1/CreateTicketStep1';
import CreateTicketStep2 from './create-ticket-step-2/CreateTicketStep2';
import CreateTicketStep3 from './create-ticket-step-3/CreateTicketStep3';
import CreateTicketStep4 from './create-ticket-step-4/CreateTicketStep4';

const CreateTicket = (props) => {
  const {
    formikProp,
    editor,
    userData,
    setUserData,
    ticketDepName,
    ticketDepartment,
    searchMacro,
    macroData,
    setSearchMacro,
    setMacroData,
    loadingCreateTicket,
  } = props;

  return (
    <CreateTicketSC>
      <CreateTicketStep1 formikProp={formikProp} userData={userData} setUserData={setUserData} />
      <CreateTicketStep2 formikProp={formikProp} ticketDepartment={ticketDepartment} ticketDepName={ticketDepName} />
      <CreateTicketStep3 formikProp={formikProp} />
      <CreateTicketStep4
        searchMacro={searchMacro}
        macroData={macroData}
        setSearchMacro={setSearchMacro}
        setMacroData={setMacroData}
        formikProp={formikProp}
        loadingCreateTicket={loadingCreateTicket}
        editor={editor}
      />
    </CreateTicketSC>
  );
};
export default CreateTicket;
